import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { MinusIcon, PlusIcon } from '@mote/assets/icons'
import { Block, BlockGroup, Button, Text } from '@mote/ui'
import { QuantityInputBox } from '../styles.pricing.page'

export const UnlimitedTierPricingSection = ({ products }) => {
  const [quantity, setQuantity] = React.useState(1)
  const history = useHistory()

  function addToQuantity(increment) {
    if (!quantity) {
      if (increment > 0) {
        setQuantity(1)
      }
    } else {
      const newQuantity = quantity + increment
      if (products.isQuantityInRange(newQuantity)) {
        setQuantity(newQuantity)
      }
    }
  }

  function updateQuantityFromInput(e) {
    var newString = e.target.value
    if (!newString) {
      setQuantity('')
    } else
      try {
        setQuantity(parseInt(e.target.value))
      } catch {}
  }

  function getUnlimitedButtonText() {
    if (products.isLoading()) {
      return 'Fetching pricing ...'
    } else if (!quantity) {
      return 'Enter a quantity'
    } else if (products.isQuantityTooHigh(quantity)) {
      return 'See Schools for best deals'
    } else {
      return 'Buy for ' + products.getTotalPrice(quantity) + ' per year'
    }
  }

  function getPricePerUserText() {
    var unitPrice = products.getUnitPrice(quantity)
    if (!unitPrice) {
      return ''
    } else {
      return unitPrice + ' per user/year'
    }
  }

  function isUnlimitedButtonDisabled() {
    return !(products.isLoaded() && products.isQuantityInRange(quantity))
  }

  return (
    <BlockGroup gap={18}>
      <BlockGroup gap={10}>
        <Text tag='small' fontSize={14} color='rgba(35, 35, 35, 0.4)'>
          Users
        </Text>

        <Block layout='horizontal' gap={7} justify='center'>
          <IncrementButton onClick={() => addToQuantity(-1)}>
            <MinusIcon color='#232323' />
          </IncrementButton>

          <QuantityInputBox
            value={quantity}
            onChange={e => updateQuantityFromInput(e)}
          />

          <IncrementButton onClick={() => addToQuantity(+1)}>
            <PlusIcon color='#232323' />
          </IncrementButton>
        </Block>
      </BlockGroup>

      <Block gap={12}>
        <BuyButton
          text={getUnlimitedButtonText()}
          disabled={isUnlimitedButtonDisabled()}
          onClick={() => {
            history.push(products.buildUnlimitedCheckoutPath(quantity))
          }}
          style={{ text: { fontWeight: 400 } }}
        />
        <Text fontSize={14} tag='small' alignment='center'>
          {getPricePerUserText()}
        </Text>
      </Block>
    </BlockGroup>
  )
}

const BuyButton = styled(Button)`
  padding: 1px 6px;
`

const IncrementButton = styled.span`
  cursor: pointer;
  border-radius: 50%;
  height: 42px;
  width: 42px;
  display: grid;
  place-items: center;

  &:hover {
    background-color: rgba(213, 212, 218, 0.5);
  }
`
